module.exports = "/images/loading.svg?d1227bd76fb9403568521222c0e85afa";